import type { IRecordService } from "../core";
import { uidLabel } from "./quickMetaHelpers";

// Shared by the chatter surfaces (timeline / followers / documents drawer):
// the chatter + attachment endpoints ship res.user references as RAW uuids
// (no server-side M2O resolution), so the UI batch-resolves display names
// with ONE generic res.user search per load. Non-fatal: callers keep
// uuid-prefix labels (via uidLabel) when the lookup fails.
export async function resolveUserLabels(
    record: IRecordService,
    uuids: Iterable<string | null | undefined>,
): Promise<Map<string, string>> {
    const unique = [...new Set([...uuids].filter((v): v is string => Boolean(v)))];
    if (!unique.length) return new Map();
    try {
        const res = await record.search("res.user", {
            domain: [["record_uuid", "in", unique]],
            limit: unique.length,
        });
        return new Map(
            res.records.map((u) => [
                String(u.record_uuid ?? u.id ?? ""),
                typeof u.name === "string" && u.name ? u.name : uidLabel(u),
            ]),
        );
    } catch {
        return new Map();
    }
}

/** Port of the backend's build_name_search_domain (polish-prefix OR over the
    model's search fields, %q% ilike pattern — the repo's ilike does NOT
    auto-wrap wildcards). */
export function nameSearchDomain(q: string, fields: string[]): unknown[] {
    const pattern = `%${q}%`;
    const effective = fields.length ? fields : ["name"];
    if (effective.length === 1) return [[effective[0], "ilike", pattern]];
    return [...Array(effective.length - 1).fill("|"), ...effective.map((f) => [f, "ilike", pattern])];
}

/** Mirrors __ede_name_search_fields__ for the chatter pickers. */
export const PARTNER_SEARCH_FIELDS = ["name", "code", "email"];
export const USER_SEARCH_FIELDS = ["name", "email"];
